import { useSurveyContext } from '../contexts/SurveyContext';
import { ProgressBar } from './ProgressBar';
import { getCompanyLogo } from '../utils/surveyHelpers';
import { QuestionRenderer } from './QuestionRenderer';

const QUESTION_HINTS = {
  multi_choice_select: 'Select all that apply',
  multi_choice: 'Select one option',
  multi_choice_other: 'Select one option',
  excellent_to_poor: 'Select one',
  highly_to_unlikely: 'Select one',
  yes_no: 'Select one',
  one_to_five: 'Select one',
  thumbs_up_down: 'Select one',
  smiley_frowney: 'Select one',
  one_to_ten: 'Drag the slider to give your rating',
  nps: 'Drag the slider to give your rating',
  comment: 'Type your response below',
};

export const SurveyHeader = () => {
  const { survey, currentQuestion } = useSurveyContext();

  if (!survey) return null;

  const hint = currentQuestion ? QUESTION_HINTS[currentQuestion.q_type] : null;

  return (
    <div className="header">
      <div className="header-fixed">
        <div className="logo">
          <img src={getCompanyLogo(survey)} alt="Company Logo" />
        </div>
        <ProgressBar />
      </div>
      <div className="question-scroll">
        <p className="question">
          {currentQuestion ? currentQuestion.q_text : "Thank you for completing this survey."}
        </p>
        {hint && <p className="question-hint">{hint}</p>}
        {currentQuestion && <QuestionRenderer />}
      </div>
    </div>
  );
};